import React from 'react';
import { Helmet } from 'react-helmet';
import './legal.css';

const CookiePolicy = () => {
  return (
    <div className="legal-page">
      <Helmet>
        <title>Cookie Policy — dmyor</title>
        <link rel="canonical" href="https://www.dmyor.com/cookie-policy" />
        <meta name="description" content="How and why dmyor uses cookies, and how you can control them." />
        <meta property="og:title" content="Cookie Policy — dmyor" />
        <meta property="og:description" content="How and why dmyor uses cookies, and how you can control them." />
        <meta property="og:image" content="https://dmyor.com/images/og-image.png" />
        <meta property="og:url" content="https://www.dmyor.com/cookie-policy" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="legal-header">
        <div className="legal-eyebrow">dmyor</div>
        <h1>Cookie Policy</h1>
        <p className="legal-updated">Last updated: 28 June 2026</p>
      </div>

      <div className="legal-body">
        <p>
          This Cookie Policy explains how dmyor ("we", "us") uses cookies and similar
          technologies when you use our website and services (the "Service"). It should be
          read together with our <a href="/privacy-policy">Privacy Policy</a>.
        </p>

        <h2>1. What cookies are</h2>
        <p>
          Cookies are small text files placed on your device when you visit a website. They
          help the site work, keep you signed in, remember preferences, and understand usage.
          Similar technologies include local storage and session storage, which we may also use.
        </p>

        <h2>2. Cookies we use</h2>
        <ul>
          <li>
            <strong>Strictly necessary.</strong> A secure authentication cookie that keeps you
            signed in to your account. The Service cannot function without it, so it cannot be
            switched off through a consent banner. We also use local/session storage to remember
            in-app preferences such as your theme and draft inputs.
          </li>
          <li>
            <strong>Functional.</strong> Remember choices you make to improve your experience.
          </li>
          <li>
            <strong>Analytics (if enabled).</strong> Help us understand how the Service is used
            so we can improve it. These are set only where permitted or with your consent.
          </li>
        </ul>
        <p>
          We do not use cookies to sell your data or to serve third-party behavioural advertising.
        </p>

        <h2>3. Third-party cookies</h2>
        <p>
          Some features rely on third parties (for example Google when you choose Google sign-in,
          and our payment provider during checkout). These providers may set their own cookies,
          governed by their own policies.
        </p>

        <h2>4. Managing cookies</h2>
        <p>
          You can accept or decline non-essential cookies through our cookie banner where shown,
          and you can manage or delete cookies at any time in your browser settings. Blocking the
          strictly necessary authentication cookie will prevent you from signing in and using your
          account.
        </p>

        <h2>5. Changes to this Policy</h2>
        <p>
          We may update this Cookie Policy from time to time. We will post the updated version here
          with a new "Last updated" date.
        </p>

        <h2>6. Contact</h2>
        <p>
          Questions about cookies? Contact us at{' '}
          <a href="mailto:support@dmyor.com">support@dmyor.com</a>.
        </p>
      </div>
    </div>
  );
};

export default CookiePolicy;
